import type { Block } from "./Block";

/**
 * Базовая реализация любого учебного блока.
 *
 * Пока не содержит логики.
 * На следующих этапах станет владельцем TeachingElement.
 */
export abstract class BaseBlock implements Block {

    protected root!: HTMLElement;

    public mount(): void {
    }

    public update(): void {
    }

    public unmount(): void {
    }

    public getRoot(): HTMLElement {

        return this.root;

    }

}